import { Model } from "@vuex-orm/core";
import { DateTime } from "luxon";

export interface timeZoneEntity {
  value: string | null;
  text: string | null;
  geoLocationLatitude: number;
  geoLocationLongitude: number;
}

export class timeZoneEntity extends Model {
  static entity = "timeZoneEntity";
  static primaryKey = "value";
  static fields() {
    return {
      value: this.attr(null),
      text: this.string(null),
      geoLocationLatitude: this.number(0),
      geoLocationLongitude: this.number(0),
    };
  }

  get getZone() {
    return DateTime.utc().setZone(this.value).toFormat("ZZ");
  }

  get getNameWithZone() {
    return "(" + this.getZone + ") " + this.text;
  }

  get isNegative() {
    const zone: string = DateTime.utc().setZone(this.value).toFormat("ZZ");
    return zone.includes("-");
  }
}
